// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('appDemands/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('appDemands/getData', async (params, { dispatch }) => {
  dispatch(setLoading({ getData: true }))
  const response = await axios.get('/Demands/List', { params: { ...params, ServiceInvoice: false } })
  dispatch(setLoading({ getData: false }))
  return {
    params,
    data: response.data
  }
})

export const appDemandsSlice = createSlice({
  name: 'appDemands',
  initialState: {
    demands: {},
    data: [],
    totalRecords: 1,
    typeData: [],
    totalTypeRecords: 1,
    params: {},
    typeParams: {},
    loadingState: { getData: false }
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data.data.list
        state.totalRecords = action.payload.data.totalRecords
        state.params = action.payload.params
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default appDemandsSlice.reducer
